import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid, ButtonToolbar, Button } from 'react-bootstrap';
import { mobileContactOperations } from "./state";
import { authOperations } from "../Login/state";
import FormTemplate from '../../components/FormTemplate';
import { EMPTY_STRING, ERROR, MOBILE_CONTACT_VIEW, KANA_YES, KANA_NO } from '../../../utils/constants';
import { ERROR_CONTACT_NOT_EXIST, ERROR_CONTACT_RETRIEVE, CONFIRMATION_DELETE, ERROR_CONTACT_UPDATE, ERROR_CONTACT_DELETE } from '../../../utils/messages';
import { CONTACT_LIST } from './routes';
import Confirmation from '../../components/Confirmation';
import ErrorAlert from '../../components/ErrorAlert';

class ViewContact extends Component {
    constructor(props) {
        super(props)
        this.state = {
            contactNumber: EMPTY_STRING,
            sendDateTime: EMPTY_STRING,
            title: EMPTY_STRING,
            message: EMPTY_STRING,
            isOpen: false,
            isActionsAllowed: false,
            promptDelete:false,
            error: []
        };
    }

    componentDidMount() {
        this.props.setMobilePage(MOBILE_CONTACT_VIEW);

        let id = this.props.match.params.id;

        if (undefined === id) {
            this.setState({ error: [ERROR_CONTACT_NOT_EXIST], isActionsAllowed: false });
        } else {
            this.props.view({
                contactNumber: id,
                customerCode1: this.props.user.partnerCodes.mainNumber,
                customerCode2: this.props.user.partnerCodes.branchNumber
            }).then((result) => {
                if (null === result.data) {
                    this.setState({ error: [ERROR_CONTACT_NOT_EXIST], isActionsAllowed: false });
                } else {
                    let contact = result.data;
                    this.setState({
                        contactNumber: contact.contactNumber,
                        sendDateTime: contact.sendDateTime,
                        title: contact.title,
                        message: contact.message,
                        proposalId: contact.proposalId,
                        isActionsAllowed: true,
                        isOpen: contact.open
                    });
                }
            }).catch(()=>{
                this.setState({ error: [ERROR_CONTACT_RETRIEVE], isActionsAllowed: false });
            });
        }
    }

    updateStatus = (status) =>{
        const model = {
            contactNumber: this.state.contactNumber,
            customerCode1: this.props.user.partnerCodes.mainNumber,
            customerCode2: this.props.user.partnerCodes.branchNumber,
            proposalId: this.state.proposalId,
            userCode: this.props.user.credentials.user_cd,
            open: status,
        }

        this.props.updateStatus(model).then((result)=>{
            if(ERROR === result.status){
                this.setState({ error: [result.message] });
            }else{
                this.showList();
            }
        }).catch(()=>this.setState({ error: [ERROR_CONTACT_UPDATE] }));
    }

    deleteContact(){
        const model = {
            contactNumber: this.state.contactNumber,
            customerCode1: this.props.user.partnerCodes.mainNumber,
            customerCode2: this.props.user.partnerCodes.branchNumber,
            proposalId: this.state.proposalId,
            userCode: this.props.user.credentials.user_cd
        }
        this.props.deleteContact(model).then((result)=>{
            if(ERROR === result.status){
                this.setState({ error: [result.message], promptDelete: false });
            }else{
                this.showList();
            }
        }).catch(()=>this.setState({ error: [ERROR_CONTACT_DELETE], promptDelete: false }));
    }

    showList = () => {
        this.props.history.push(CONTACT_LIST);
    }

    formButtons(){
        return(
            <ButtonToolbar className="flex-center-wrap mt-30">
                <Button className="button-mobile" disabled={!this.state.isActionsAllowed || this.state.isOpen} onClick={()=>this.updateStatus(true)}>既読にする</Button>
                <Button className="button-mobile" disabled={!this.state.isActionsAllowed || !this.state.isOpen} onClick={()=>this.updateStatus(false)}>未読にする</Button>
                <Button className="button-mobile" disabled={!this.state.isActionsAllowed} onClick={()=>this.setState({promptDelete:true})}>削除</Button>
            </ButtonToolbar>
        )
    }

    render() {
        return (
            <Grid className="mobile-container">
                <Grid>
                    <ErrorAlert errors={this.state.error}/>
                    
                    <Confirmation
                        message={CONFIRMATION_DELETE}
                        showConfirmation={this.state.promptDelete}
                        buttons={[
                            { label: KANA_YES, action: ()=>{this.deleteContact()} },
                            { label: KANA_NO, action: ()=>{this.setState({promptDelete:false})} }
                        ]}
                    />

                    <FormTemplate
                        {...this.props}
                        {...this.state}
                        mobile={true}
                        disabled={true}
                        className="mt-10"
                    />
                </Grid>
                <Grid>
                    {this.formButtons()}
                </Grid>
            </Grid>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.auth,
        formInputs: state.mobileContact.contactForm
    }
};

const mapDispatchToProps = {
    view: mobileContactOperations.viewContact,
    updateStatus: mobileContactOperations.updateStatus,
    getUnreadCount: mobileContactOperations.getUnreadCount,
    deleteContact: mobileContactOperations.deleteContact,
    setMobilePage: authOperations.setMobilePage
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewContact);